// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-react-" + {"454":"6321965f894bc8534033","530":"6bbde5ae959f7ddbfa61"}[chunkId] + ".js";
};